const toSaveRequest = (contentBlock, status = "published") => ({
    id: contentBlock.id,
    systemName: contentBlock.systemName,
    templateType: contentBlock.templateType,
    active: contentBlock.active,
    isPinned: contentBlock.isPinned,
    title: contentBlock.title,
    description: contentBlock.description,
    contentBlock: { ...contentBlock.contentBlock },
    tags: [...contentBlock.categories],
    processTags: [...contentBlock.processTags],
    packDocuments: contentBlock.documentPackContents.map(pack => ({
        id: pack.id,
        type: pack.templateType,
        outputTitle: pack.outputTitle,
        outputFileName: pack.outputFileName,
        copies: pack.copies,
        isMandatory: pack.isMandatory,
        order: pack.order,
        sources: pack.sources.map(source => ({
            id: source.id,
            htmlContent: source.htmlContent,
            filePath: source.filePath,
            order: source.order,
            rules: [...source.rules],
            status: status
        }))
    }))
});

export {
    toSaveRequest
}

export default {
    toSaveRequest
}